import React from 'react';
import styled from 'styled-components';
import { SlideHeader, ImpactClaimLocation } from 'components/Shared';
import { useTranslation } from 'react-i18next';
import { ImpactClaimDocumentsList } from 'components/Shared/ImpactClaims';
import { useStackableBreadcrumbs, useStackableContent, } from 'components/Shared/StackedContent/StackableContentContext';
import { ProductJourneyPages } from '../pages';
import { getPrimaryImage } from 'utils/supplyChain';
const Container = styled.div `
  padding: 0 32px 32px 32px;
  overflow: auto;
`;
const DocumentSlide = ({ mobile, detailNode, documents, }) => {
    const { t } = useTranslation();
    const { deactivateActiveContent } = useStackableContent();
    const breadcrumbs = useStackableBreadcrumbs();
    return (React.createElement("div", null,
        React.createElement(SlideHeader, { mobile: mobile, onPrev: deactivateActiveContent, breadcrumbs: breadcrumbs, labelBackLink: t('back-to-impact-claim'), backToStartCrumb: { type: ProductJourneyPages.PRODUCT_JOURNEY } }),
        React.createElement(Container, null,
            React.createElement(ImpactClaimLocation, { title: detailNode === null || detailNode === void 0 ? void 0 : detailNode.title, location: detailNode === null || detailNode === void 0 ? void 0 : detailNode.site.locationName, locationImage: getPrimaryImage(detailNode === null || detailNode === void 0 ? void 0 : detailNode.mediaList) }),
            React.createElement(ImpactClaimDocumentsList, { attachments: documents.edges }))));
};
export default DocumentSlide;
